import moment from 'moment'

export class DateFormatService {
  constructor() {
  }

  // set date without time zone to display
  standardDisplayFormatDate(date: any) {
    let mindiff = new Date().getTimezoneOffset();
    return new Date(moment(date).add(mindiff, 'minutes').toISOString())
  }

  // convert date to iso string without time zone to Api
  standardSendFormatDate(date: Date) {
    return moment(date).utc(true).toISOString();
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/date-format.service.ts